import React from 'react'

import {Headline, HeadlineProps} from './Headline'

export function PageTitle(props: Omit<HeadlineProps, 'tag' | 'bottomSpacing'>) {
  return <Headline tag="h2" bottomSpacing={1} {...props} />
}
